/* lua.js generated code 0.3.0 */
 //-新手奖励相关逻辑
const Event = require("hecore/EventDispatcher").Event
let UserNewReward = xClass("UserNewReward", Event)
var instance = null
UserNewReward.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserNewReward.new()
        instance.init()
    }
    return instance
}
UserNewReward.prototype.ctor = function () {
}
UserNewReward.prototype.init = function () {
}
UserNewReward.prototype.isRewardGet = function () {
    var self = this
    if (UserManager.getInstance().getUserExtendRef().getNewUserReward() === 1) {
        return true
    } else {
        return false
    }
}
UserNewReward.prototype.isShortCutRewardGet = function () {
    var self = this
    if (UserManager.getInstance().getUserExtendRef().getShortcutReward() === 1) {
        return true
    } else {
        return false
    }
}
UserNewReward.prototype.getShortCutRewards = function (successCallback, failCallback) {
    var self = this
    var itemMeta = MetaManager.getInstance().getSetShortcutRewards()
    cc.log(table.tostring(itemMeta))
    function onSuccess() {
        //
        UserManager.getInstance().getUserExtendRef().setShortcutReward(1)
        for (var k = 1, v = itemMeta[1]; v; k++, v = itemMeta[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.SHORTCUT_REWARD)
        }
        if (successCallback) {
            successCallback()
        }
    }
    function onFail() {
        if (failCallback) {
            failCallback()
        }
    }
    function onCancel() {
    }
    var http = GetSetShortcutRewardsHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}
UserNewReward.prototype.getNewUserRewardsWx = function (successCallback, failCallback, data) {
    var self = this
    var itemMeta = MetaManager.getInstance().getNewUserRewards()
    cc.log(table.tostring(itemMeta))
    function onSuccess() {
        UserManager.getInstance().getUserExtendRef().setNewUserReward(1)
        if (successCallback) {
            successCallback()
        }
    }
    function onFail() {
        if (failCallback) {
            failCallback()
        }
    }
    function onCancel() {
    }
    var http = GetNewUserRewardsHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(data)
}
UserNewReward.prototype.getNewUserRewards = function (successCallback, failCallback, data) {
    var self = this
    var itemMeta = MetaManager.getInstance().getNewUserRewards()
    cc.log(table.tostring(itemMeta))
    function onSuccess() {
        UserManager.getInstance().getUserExtendRef().setNewUserReward(1)
        for (var k = 1, v = itemMeta[1]; v; k++, v = itemMeta[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.NEW_USER)
        }
        if (successCallback) {
            successCallback()
        }
    }
    function onFail() {
        if (failCallback) {
            failCallback()
        }
    }
    function onCancel() {
    }
    var http = GetNewUserRewardsHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(data)
}

UserNewReward.prototype.getSetQzoneBackgroundRewards = function (successCallback, failCallback) {
    var self = this
    var itemMeta = MetaManager.getInstance().getSetQzoneBackgroundRewards()
    cc.log(table.tostring(itemMeta))
    function onSuccess() {
        for (var k = 1, v = itemMeta[1]; v; k++, v = itemMeta[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.QZONEBACKGOUND_REWARD)
        }
        if (successCallback) {
            successCallback()
        }
    }
    function onFail() {
        if (failCallback) {
            failCallback()
        }
    }
    function onCancel() {
    }
    var http = FetchCoverRewardsHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}

module.exports = UserNewReward